import { motion } from "framer-motion";

export default function SpritzBadge() {
  return (
    <motion.div
      data-testid="spritz-badge"
      className="absolute right-4 top-20 z-20 flex h-24 w-24 flex-col items-center justify-center gap-1.5 rounded-full border-2 border-gold bg-ink/85 shadow-[0_0_40px_rgba(212,175,55,0.3)] backdrop-blur-sm md:right-14 md:top-28 md:h-36 md:w-36 md:gap-2"
      initial={{ scale: 0, rotate: -12 }}
      animate={{ scale: 1, rotate: 0, y: [0, -6, 0] }}
      transition={{
        scale: { delay: 1.3, duration: 0.5, ease: [0.16, 1, 0.3, 1] },
        rotate: { delay: 1.3, duration: 0.5 },
        y: { delay: 1.9, duration: 3.2, repeat: Infinity, ease: "easeInOut" },
      }}
    >
      <svg
        viewBox="0 0 64 64"
        className="h-7 w-7 md:h-9 md:w-9"
        aria-hidden="true"
      >
        <path
          d="M18 10 h28 c0 14 -5 22 -14 22 s-14 -8 -14 -22 Z"
          fill="rgba(245,245,240,0.14)"
          stroke="#F5F5F0"
          strokeWidth="2"
        />
        <path
          d="M21 16 h22 c-0.5 10 -4.5 16 -11 16 s-10.5 -6 -11 -16 Z"
          fill="#E8892B"
        />
        <circle cx="26" cy="21" r="1.2" fill="rgba(255,255,255,0.85)" />
        <circle cx="36" cy="25" r="1" fill="rgba(255,255,255,0.7)" />
        <circle
          cx="42"
          cy="13"
          r="5.5"
          fill="#F2A03D"
          stroke="#F5F5F0"
          strokeWidth="1.5"
        />
        <circle cx="42" cy="13" r="2.8" fill="none" stroke="#C96A18" strokeWidth="1" />
        <path d="M32 32 v10" stroke="#F5F5F0" strokeWidth="2" />
        <path
          d="M26 44 h12"
          stroke="#F5F5F0"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <img
        src="/logos/lillet.png"
        alt="Lillet"
        data-testid="badge-lillet-logo"
        className="mt-1 h-3.5 w-auto md:mt-2 md:h-4"
      />
      <span className="text-[8px] font-medium uppercase tracking-[0.18em] text-gold md:text-[10px]">
        Offert
      </span>
    </motion.div>
  );
}
